import { connect } from 'react-redux';
import Comment from './Comment';
import { getCommentList, getCommentListLoadingStatus } from '../../../../store/selectors/license.selectors';
import { getAuthenticationToken } from '../../../../store/actions/authentication.actions';

const mapStateToProps = (state: any) => {
    const data = getCommentList(state);
    const loading = getCommentListLoadingStatus(state);
    return { data, loading };
};
const mapDispatchToProps = {
    getAuthenticationToken: getAuthenticationToken,
};
export default connect(mapStateToProps, mapDispatchToProps)(Comment);
